import { Component, inject } from '@angular/core';
import type { Route, UrlSegment, UrlTree } from '@angular/router';
import { Router } from '@angular/router';

import type { UrlActionTrigger } from './url-action-trigger.types';
import { URL_ACTION_TRIGGER_BASE_PATH } from './url-action-trigger.types';

@Component({
  standalone: true,
  template: ``,
})
export class UrlActionTriggerRouteNoopComponent {}

export const provideUrlActionTriggerRoute = (
  handlersMap: Record<UrlActionTrigger, Function>,
): Route => ({
  path: `${URL_ACTION_TRIGGER_BASE_PATH}/:action`,
  canMatch: [
    (route: Route, segments: UrlSegment[]) => {
      if (route.path?.startsWith(segments[0].toString())) {
        const action = <UrlActionTrigger>segments[1].toString();
        const option = segments[2] ? <string | undefined>segments[2].toString() : undefined;

        if (action in handlersMap) {
          try {
            handlersMap[action]((option && decodeURIComponent(option)) || option);
          } catch (err) {
            console.warn(`Error while handling url-action-trigger: ${action}, option: ${option}`);
            console.error(err);
          }
        }
      }

      const router = inject(Router);

      // if user enters url-action-trigger page directly, redirect them to dashboard as this is noop route
      if (!router.getCurrentNavigation()?.previousNavigation) {
        return router.navigate(['/']);
      }

      return <UrlTree>router.getCurrentNavigation()?.previousNavigation?.finalUrl;
    },
  ],
  component: UrlActionTriggerRouteNoopComponent,
});
